import React, {useEffect, useState} from 'react'
import {useHistory} from 'react-router-dom'
import {Lesson} from '../../api/course'
import {Card} from 'antd'

import './grade.less'
import {ObsKeyToURL} from 'api/utils'
import API from 'api'
import {newUser, User} from 'api/user'

interface Props {
  lesson: Lesson
  total: number
  grade_id?: number
}

const LessonCard: React.FC<Props> = ({lesson, total, grade_id}) => {
  const history = useHistory()

  const [user, setUser] = useState<User>(newUser())
  useEffect(() => {
    setUser(JSON.parse(sessionStorage.getItem('user-info') || '{}'))
  }, [])
  const toCourse = () => {
    if (grade_id) {
      history.push({
        pathname: '/courses/' + lesson.id,
        state: {
          course: lesson,
          total: total,
          grade_id: grade_id,
        },
      })
    } else {
      API.addRecord({
        course_id: lesson.id,
        course: lesson,
        user_id: user.user_id,
        created_at: new Date().toISOString(),
      })
      history.push({
        pathname: '/courses/' + lesson.id,
        state: {
          course: lesson,
          total: total,
        },
      })
    }
  }

  return (
    <>
      <Card
        onClick={toCourse}
        className="course-card"
        hoverable
        cover={<img alt="课程" src={ObsKeyToURL(lesson.image)} />}
      >
        <Card.Meta title={lesson.name} description={`第${lesson.renderSort}课时`}></Card.Meta>
      </Card>
    </>
  )
}

export default LessonCard
